import type {
  CitizenSummary,
  IncidentSummary,
  ReportSummary,
} from "@hydeck/mdt-contracts";
import { createResource } from "solid-js";
import { DumpList } from "../components/DumpList";
import { apiRequest } from "../core/api";
import { currentUser } from "../core/session";

const fallbackProfile =
  "https://assets.nopixel.net/dev/images/mdt/mdt_no_profile_picture.png";

export function BookmarksPage() {
  const [profiles] = createResource(() =>
    readBookmarks<CitizenSummary>("profile"),
  );
  const [incidents] = createResource(() =>
    readBookmarks<IncidentSummary>("incident"),
  );
  const [reports] = createResource(() =>
    readBookmarks<ReportSummary>("report"),
  );

  return (
    <div class="flex h-full w-full flex-col gap-4 lg:flex-row">
      <section class="block w-full lg:w-1/3">
        <DumpList
          label="Profiles"
          loading={profiles.loading}
          entries={(profiles() ?? []).map((profile) => ({
            id: profile.id,
            title: profile.name,
            avatar: profile.profilePicture ?? fallbackProfile,
            leftLabel: `ID: ${profile.id}`,
          }))}
        />
      </section>
      <section class="block w-full lg:w-1/3">
        <DumpList
          label="Incidents"
          loading={incidents.loading}
          entries={(incidents() ?? []).map((incident) => ({
            id: incident.id,
            title: incident.title,
            description: incident.description,
            icon: "nav_legislation",
            leftLabel: `ID: ${incident.id}`,
          }))}
        />
      </section>
      <section class="block w-full lg:w-1/3">
        <DumpList
          label="Reports"
          loading={reports.loading}
          entries={(reports() ?? []).map((report) => ({
            id: report.id,
            title: report.title,
            description: report.description,
            icon: "bolo_docs",
            leftLabel: `ID: ${report.id}`,
          }))}
        />
      </section>
    </div>
  );
}

async function readBookmarks<T>(type: "profile" | "incident" | "report") {
  try {
    return await apiRequest<T[]>(`/bookmarks/${type}`, {
      token: currentUser()?.accessToken,
    });
  } catch {
    return [];
  }
}
